import { ReactNode } from 'react';
import { CopyType, Tool } from '../../../store//types/prescription';
import { PadDForm } from '../../../api/pushVisit';
import { Actions } from '../../../store/actions';
import { upsertDyForm } from '../../../store/actions/prescriptionPad';

export const DEFAULT_CONFIG: {
    createCopyAction: (
        visit: Tool & { date: string },
        id: keyof Tool,
        type?: CopyType,
    ) => Actions | undefined | Actions[];
    icon: {
        cssClass: string;
        text: JSX.Element | string;
        tooltipContent: (visit: Tool, id: keyof Tool) => ReactNode;
    };
    content: (visit: Tool, id: keyof Tool) => ReactNode | null;
} = {
    createCopyAction: (visit, id) => {
        if (!visit.dyform) {
            return;
        }

        const item = visit.dyform.find((t) => t.id === id);
        if (!item || !(item as PadDForm).elements?.length) {
            return;
        }
        return upsertDyForm(item as PadDForm);
    },
    icon: {
        cssClass: 'bg-darwin-neutral-50',
        tooltipContent: (visit: Tool, id: keyof Tool) => {
            if (!visit.dyform) {
                return null;
            }

            const item = visit.dyform.find((t) => t.id === id);
            if (!item || !(item as PadDForm).elements?.length) {
                return null;
            }
            return (item as PadDForm).name;
        },
        text: (
            <svg width="12" height="11" viewBox="0 0 12 11" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.25 10.75L11.25 7.75H8.25V10.75ZM10.125 0.25H1.875C1.24219 0.25 0.75 0.742188 0.75 1.375V9.625C0.75 10.2578 1.24219 10.75 1.875 10.75H7.5V7.75C7.5 7.35156 7.82812 7 8.25 7H11.25V1.375C11.25 0.765625 10.7344 0.25 10.125 0.25ZM8.25 5.3125C8.25 5.42969 8.15625 5.5 8.0625 5.5H6.75V6.8125C6.75 6.92969 6.65625 7 6.5625 7H5.4375C5.32031 7 5.25 6.92969 5.25 6.8125V5.5H3.9375C3.82031 5.5 3.75 5.42969 3.75 5.3125V4.1875C3.75 4.09375 3.82031 4 3.9375 4H5.25V2.6875C5.25 2.59375 5.32031 2.5 5.4375 2.5H6.5625C6.65625 2.5 6.75 2.59375 6.75 2.6875V4H8.0625C8.15625 4 8.25 4.09375 8.25 4.1875V5.3125Z"
                    fill="#616A8F"
                />
            </svg>
        ),
    },
    content: (visit: Tool, id: keyof Tool) => {
        if (!visit.dyform) {
            return null;
        }

        const item = visit.dyform.find((t) => t.id === id);
        if (!item || !(item as PadDForm).elements?.length) {
            return null;
        }

        return (
            <div>
                <p className="text-12 text-neutral-black font-700 uppercase">
                    {(item as PadDForm)?.name}
                </p>
                <ul>
                    {(item as PadDForm)?.elements?.map((e) => (
                        <li key={e.id}>
                            {' '}
                            <span className="font-700">{e.name}:</span>{' '}
                            <span className="">{e.value}</span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    },
};
